import { createContext,useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import Layout from "./components/Layout";
import HomePage from './components/HomePage';
import ReportForm from './components/ReportForm';
import ReportsList from './components/ReportsList';
import ReportDetail from './components/ReportDetail';
import UserDashboard from './components/UserDashboard';
import SupportTickets from './components/SupportTickets';
import ModeratorPanel from './components/ModeratorPanel';
import ModeratorDashboard from './components/ModeratorDashboard';
import AdminDashboard from './components/AdminDashboard';
import { Toaster } from './components/ui/sonner';
import './App.css';
import AboutUs from "./components/AboutUs";  

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Set up axios defaults
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const AuthContext = React.createContext(null);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      axios.get(`${API}/users/me`)
        .then(res => setUser(res.data))
        .catch(() => {
          localStorage.removeItem('authToken');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('authToken', token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setUser(null);
  };

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
          <Route element={<Layout user={user} login={login} logout={logout} />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/report" element={user ? <ReportForm /> : <Navigate to="/" />} />
            <Route path="/reports" element={<ReportsList />} />
            <Route path="/reports/:id" element={<ReportDetail />} />
            <Route path="/dashboard" element={user ? <UserDashboard /> : <Navigate to="/" />} />
            <Route path="/support" element={user ? <SupportTickets /> : <Navigate to="/" />} />
            <Route path="/support/refund" element={user ? <SupportTickets /> : <Navigate to="/" replace />}/>
            <Route path="/moderator" element={user && user.role === 'moderator' ? <ModeratorPanel /> : <Navigate to="/" />} />
            <Route path="/moderator/dashboard" element={user && user.role === 'moderator' ? <ModeratorDashboard /> : <Navigate to="/" />} />
            <Route path="/admin" element={user && (user.role === 'super_admin' || user.role === 'admin') ? <AdminDashboard /> : <Navigate to="/" />} />
          </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthContext.Provider>
  );
}

export default App;

import React from 'react';